import { useTranslation as e } from "../../i18n.mjs";
import { FieldFeedback as t } from "../../components/field-feedback/index.mjs";
import { toast as n } from "../../components/toast/index.mjs";
import { isImageFile as r } from "../../utils/is-image.mjs";
import { areAspectRatiosEqual as i, getImageAspectRatio as ee } from "../../utils/aspect-ratio.mjs";
import { getArrayDifferenceBy as a } from "../../utils/get-array-difference-by.mjs";
import { fileInputAcceptTypes as o } from "../../utils/file-input-accept-types.mjs";
import { FileDropZone as te } from "../../components/file-drop-zone/index.mjs";
import { FileItem as s } from "../../components/file-item/file-item.mjs";
import { FileUploaderItemStateEnum as c } from "./types/file-uploader-item-type.mjs";
import { useFileUploaderManager as l } from "./hooks/use-file-uploader-manager.mjs";
import { Modal as u } from "../../components/modal/index.mjs";
import { ImageCropperModal as ne } from "../image-cropper/image-cropper-modal.mjs";
import { Button as d } from "@systemeio/components";
import { useEffect as f, useState as p } from "react";
import { useStateWatcher as m } from "@systemeio/util";
import { Trans as h } from "react-i18next";
import { twMerge as g } from "tailwind-merge";
import { Fragment as re, jsx as _, jsxs as v } from "react/jsx-runtime";
//#region src/modules/file-uploader/file-uploader-modal.tsx
var y = ({ uploaderRef: y, opened: ie, source: b, imageCropperModalProps: x, showCroppingNote: ae, acceptTypes: S, fileManagerApiType: oe, actionLabel: se, singleFileMode: C, openCroppingModalOnAdding: ce, requireCropping: le, onClose: w, onDone: T }) => {
	let { t: E, tICU: D, i18n: ue } = e(), [O, k] = p(!1), [de, A] = p(), { items: j, waitingUploadItems: M, waitingUploadFiles: N, uploadedFiles: P, replaceWaitingUploadFiles: F, addFilesToWaitingUpload: I, replaceFileInWaitingUploadItem: L, deleteWaitingUploadItem: R, deleteUploadingItem: z, startUploading: B, startUploadingAll: V, clearAll: H } = l({
		fileManagerApiType: oe,
		source: b
	}), fe = S?.join(",") === o.image?.join(","), U = O || j.some((e) => e.state === c.Uploading), W = !!j.length, pe = !!N.length, G = P.length, K = j.length, me = G && K === G;
	f(function() {
		j.some((e) => e.state === c.Waiting && e.error) || A(void 0);
	}, [j]);
	let q = async (e) => {
		let t = x?.imageCropperProps?.aspectRatio;
		if (!r(e) || !t || isNaN(t)) return !0;
		let n = URL.createObjectURL(e), [a, o] = await ee(n);
		return !!i(o, t);
	};
	m(M, async (e, t) => {
		if (!ce) return;
		let { added: n } = e ? a(e, t, (e) => e.uid) : { added: t };
		for (let e of n) if (!await q(e.file)) {
			Q(e);
			break;
		}
	}), m(N, async (e, t) => {
		if (!ae) return;
		let { added: r } = e ? a(e, t, (e) => e) : { added: t };
		for (let e of r) if (!await q(e)) {
			n(E("file_manager.image_cropper.aspect_ratio.need_to_crop_note", { name: e.name }));
			break;
		}
	});
	let he = async (e) => {
		if (C) F(e);
		else {
			let t = I(e);
			t > 0 && n(D("file_manager.file_upload.duplicates_skipped", { count: t }));
		}
	}, J = () => {
		U || (P.length && T(P), w());
	}, ge = () => {
		U || (T(P), w());
	}, _e = async () => {
		let e = N;
		if (e.length) try {
			if (A(void 0), k(!0), le) {
				for await (let t of e) if (!await q(t)) throw Error(E("file_manager.image_cropper.aspect_ratio.need_to_crop_note", { name: t.name }));
			}
			let t = await V(), r = t.filter((e) => e.status === "fulfilled").map((e) => e.value).filter((e) => !!e), i = t.filter((e) => e.status === "rejected");
			if (i.length) throw Error(D("file_manager.file_upload.upload_incomplete_error", {
				totalFailed: i.length,
				totalFiles: e.length
			}));
			r.length && n.success(E("file_manager.file_upload.uploaded_successfully"));
		} catch (e) {
			let t = e instanceof Error ? e : Error(E("file_manager.error"));
			A(t);
		} finally {
			k(!1);
		}
	}, ve = (e) => {
		B(e.uid).catch(() => {});
	}, [ye, Y] = p(!1), [X, Z] = p(), Q = (e) => {
		Y(!0), Z(e);
	}, $ = () => {
		Y(!1), Z(void 0);
	};
	return y && (y.current = { addFilesToWaitingUpload: I }), /* @__PURE__ */ v(re, { children: [/* @__PURE__ */ _(u, {
		title: E("file_manager.file_upload.upload_files"),
		isFetching: U,
		opened: ie,
		onClose: J,
		afterLeave: () => H(),
		footer: /* @__PURE__ */ v("div", {
			className: "flex w-full items-center gap-3",
			children: [K > 0 && /* @__PURE__ */ _("div", {
				className: "text-text-tertiary text-sm",
				children: E("file_manager.file_upload.files_uploaded", {
					count: G,
					totalCount: K
				})
			}), /* @__PURE__ */ v("div", {
				className: "flex flex-1 items-center justify-end gap-3",
				children: [/* @__PURE__ */ _(d, {
					className: "tablet:inline-flex hidden",
					variant: "secondary",
					onClick: J,
					disabled: U,
					children: E("file_manager.cancel")
				}), me ? /* @__PURE__ */ _(d, {
					className: "tablet:flex-none flex-1",
					onClick: ge,
					disabled: U,
					children: E("file_manager.done")
				}) : /* @__PURE__ */ _(d, {
					className: "tablet:flex-none flex-1",
					isLoading: O,
					onClick: _e,
					disabled: !pe && !O,
					children: se ?? E("file_manager.upload")
				})]
			})]
		}),
		children: /* @__PURE__ */ v("div", {
			className: "flex flex-col gap-5",
			children: [
				/* @__PURE__ */ _(te, {
					acceptTypes: S,
					onSelect: he,
					dropZoneClassName: g(!W && "items-center"),
					label: /* @__PURE__ */ _(h, {
						i18n: ue,
						i18nKey: "file_manager.file_upload.drag_files",
						components: { span: /* @__PURE__ */ _("span", { className: "text-text-link" }) }
					}),
					description: fe && E("file_manager.file_upload.accepts_jpg_png_files"),
					disabled: U,
					multiple: !C
				}),
				W && /* @__PURE__ */ _("div", {
					className: "flex flex-col gap-1",
					children: j.map((e) => e.state === c.Waiting ? /* @__PURE__ */ _(s, {
						wide: !0,
						file: e.file,
						error: e.error,
						showEditButton: r(e.file),
						onEdit: () => Q(e),
						showDeleteButton: !0,
						onDeleteFile: () => R(e.uid),
						onRetryAfterError: () => ve(e)
					}, e.uid) : e.state === c.Uploading ? /* @__PURE__ */ _(s, {
						wide: !0,
						file: e.file,
						progress: typeof e.progress == "number" && e.progress < 5 ? 5 : e.progress,
						isLoading: !0,
						showDeleteButton: !0,
						onDeleteFile: () => z(e.uid)
					}, e.uid) : e.state === c.Uploaded ? /* @__PURE__ */ _(s, {
						wide: !0,
						file: e.file,
						isLoaded: !0
					}, e.uid) : e.state === c.Deleting ? /* @__PURE__ */ _(s, {
						wide: !0,
						file: e.file,
						isDeleting: !0
					}, e.uid) : null)
				}),
				/* @__PURE__ */ _(t, {
					error: de?.message,
					className: "text-center"
				})
			]
		})
	}), /* @__PURE__ */ _(ne, {
		imageFile: X?.file,
		opened: ye,
		onClose: $,
		onCrop: (e) => {
			X && (L(X.uid, e), $());
		},
		...x
	})] });
};
//#endregion
export { y as FileUploaderModal };
